import Cookies from "js-cookie";

const DEFAULT_RETRY_DELAYS = [1000, 2000, 5000, 15000, 30000];

export function createResponderEventSource({
  path,
  query = {},
  withToken = true,
  eventListeners = {},
  onOpen,
  onError,
  retryDelays = DEFAULT_RETRY_DELAYS,
} = {}) {
  let eventSource;
  let closed = false;
  let attempt = 0;

  const normalizePath = (rawPath) => {
    if (!rawPath) return "";
    return rawPath.startsWith("/") ? rawPath : `/${rawPath}`;
  };

  const buildUrl = () => {
    const base = (process.env.PUBLIC_API_URL || "").replace(/\/$/, "");
    const params = new URLSearchParams(query);
    if (withToken) {
      const token = Cookies.get("accessToken");
      if (token) params.set("token", token);
    }
    const qs = params.toString();
    return `${base}${normalizePath(path)}${qs ? `?${qs}` : ""}`;
  };

  const cleanup = () => {
    if (eventSource) {
      eventSource.close();
      eventSource = null;
    }
  };

  const scheduleReconnect = () => {
    if (closed) return;
    cleanup();
    const delay =
      retryDelays[Math.min(attempt, retryDelays.length - 1)] ??
      retryDelays[retryDelays.length - 1] ??
      1000;
    attempt += 1;
    setTimeout(connect, delay);
  };

  const handleOpen = (evt) => {
    attempt = 0;
    if (typeof onOpen === "function") onOpen(evt);
  };

  const handleError = (evt) => {
    if (typeof onError === "function") onError(evt);
    scheduleReconnect();
  };

  const connect = () => {
    if (closed) return;
    try {
      eventSource = new EventSource(buildUrl());
      eventSource.addEventListener("open", handleOpen);
      eventSource.addEventListener("error", handleError);
      Object.entries(eventListeners || {}).forEach(([eventName, handler]) => {
        if (typeof handler === "function") {
          eventSource.addEventListener(eventName, handler);
        }
      });
    } catch (err) {
      handleError(err);
    }
  };

  connect();

  return {
    close: () => {
      closed = true;
      cleanup();
    },
  };
}
